import { Navigate, Outlet } from 'react-router-dom';

const useAuth = async () => {
    const user = localStorage.getItem("isLoggedIn");
    return user;
}

const PrivateRoute = () => {
    let authUser = useAuth();
    return authUser ? <Outlet /> : <Navigate to="/login" />;
}

export default PrivateRoute;